import { APP_NAME } from 'app-config'

import { IRequestOptions, IResponseResult } from 'models/api.model'
import { IRawSubscription } from 'models/subscriptions.model'

import { ApiService } from 'services/api.service'

import { RequestMethod, SubscriptionListType } from 'root-constants'
import { TAppName } from 'root-types'

export class SubscriptionsApi {
  private api: ApiService
  private readonly appName: TAppName = APP_NAME

  constructor(api: ApiService) {
    this.api = api
  }

  getSubscriptionList({
    cohort,
    type,
    uuid,
    tags = '',
  }: {
    cohort: string
    type: SubscriptionListType
    uuid: string
    tags?: string
  }): Promise<IResponseResult<{ plans: IRawSubscription }>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { plan_type: type, uuid, tags },
    }

    return this.api.makeRequest<{ plans: IRawSubscription }>(
      `v2/plans/${this.appName}/${cohort}`,
      options,
    )
  }
}
